export default __webpack_public_path__ + "static/media/1710.e811dbe7.png";